/**
 * Kullanıcının cihazının timezone bilgisini alır
 * @returns {string} Timezone string (örn: "Europe/Istanbul", "America/New_York")
 */
export const getCurrentTimezone = () => {
    try {
        // Intl.DateTimeFormat().resolvedOptions().timeZone ile timezone alınır
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
        console.warn('Timezone alınamadı:', error);
        // Fallback olarak UTC döndür
        return 'UTC';
    }
};

/** Doktor profil / randevu ayarlarında kullanılan IANA timezone listesi */
export const DOCTOR_TIMEZONE_OPTIONS = [
    "Europe/Istanbul",
    "Europe/London",
    "Europe/Berlin",
    "America/New_York",
    "Asia/Dubai",
    "UTC",
];

/**
 * Timezone offset'ini alır (dakika cinsinden)
 * @returns {number} Timezone offset in minutes
 */
export const getTimezoneOffset = () => {
    return new Date().getTimezoneOffset();
}; 